module.exports = __webpack_public_path__ + "static/media/hsf.b341385b.png";